import { PushNotificationTest } from '@/components/PushNotificationTest';

const PushNotificationTestPage = () => {
  return (
    <div className="container mx-auto max-w-4xl p-4 pb-24">
      <PushNotificationTest />
    </div>
  );
};

export default PushNotificationTestPage;
